"use strict";

var _regeneratorRuntime = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/overall-web-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchOnlyDocuments = void 0;

var RequestWithCache_1 = __importDefault(require("./RequestWithCache"));

var Collections_1 = __importDefault(require("./Collections"));

var RESOURCEPATH = '/documents';

var SearchOnlyDocuments = /*#__PURE__*/function () {
  function SearchOnlyDocuments(collectionName, apiCall, configuration) {
    _classCallCheck(this, SearchOnlyDocuments);

    this.collectionName = collectionName;
    this.apiCall = apiCall;
    this.configuration = configuration;
    this.requestWithCache = new RequestWithCache_1.default();
  }

  _createClass(SearchOnlyDocuments, [{
    key: "search",
    value: function () {
      var _search = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(searchParameters) {
        var _ref,
            _ref$cacheSearchResul,
            cacheSearchResultsForSeconds,
            _ref$abortSignal,
            abortSignal,
            additionalQueryParams,
            queryParams,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _ref = _args.length > 1 && _args[1] !== undefined ? _args[1] : {}, _ref$cacheSearchResul = _ref.cacheSearchResultsForSeconds, cacheSearchResultsForSeconds = _ref$cacheSearchResul === void 0 ? this.configuration.cacheSearchResultsForSeconds : _ref$cacheSearchResul, _ref$abortSignal = _ref.abortSignal, abortSignal = _ref$abortSignal === void 0 ? null : _ref$abortSignal;
                additionalQueryParams = {};

                if (this.configuration.useServerSideSearchCache === true) {
                  additionalQueryParams['use_cache'] = true;
                }

                queryParams = Object.assign({}, searchParameters, additionalQueryParams);
                return _context.abrupt("return", this.requestWithCache.perform(this.apiCall, this.apiCall.get, [this.endpointPath('search'), queryParams, {
                  abortSignal: abortSignal
                }], {
                  cacheResponseForSeconds: cacheSearchResultsForSeconds
                }));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function search(_x) {
        return _search.apply(this, arguments);
      }

      return search;
    }()
  }, {
    key: "endpointPath",
    value: function endpointPath(operation) {
      return "".concat(Collections_1.default.RESOURCEPATH, "/").concat(this.collectionName).concat(RESOURCEPATH).concat(operation === undefined ? '' : '/' + operation);
    }
  }], [{
    key: "RESOURCEPATH",
    get: function get() {
      return RESOURCEPATH;
    }
  }]);

  return SearchOnlyDocuments;
}();

exports.SearchOnlyDocuments = SearchOnlyDocuments;